import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { fontGate } from '@/bootstrap/fonts';
import { placeholders } from '@/copy/placeholders';
import { installCssVars } from '@/theme/cssVars';

import './styles.css';

installCssVars();
// The tab title is user-visible copy too: it comes from placeholders.ts, not from index.html alone.
document.title = placeholders.app.title;

// First paint waits for Poppins (or the fail-open timeout) so @kk/ui Text never flashes a system font.
void fontGate().then(() => {
  const el = document.getElementById('root');
  if (!el) throw new Error('#root missing');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
